import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function MissionVisionSection() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-16 md:py-20 bg-secondary-50/30">
      <div ref={ref} className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Mission */}
          <div className="group relative bg-card-50 rounded-2xl border border-primary-200/30 p-8 md:p-10 shadow-sm hover:shadow-md hover:border-primary-300/50 transition-all cursor-default overflow-hidden card-animate">
            <div className="absolute top-0 right-0 w-32 h-32 bg-primary-100/30 rounded-bl-full -mr-4 -mt-4"></div>
            <div className="relative z-10">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 mb-5">
                <span className="text-xs font-semibold text-primary-700 uppercase tracking-wider">Mission</span>
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-bold text-primary-700 mb-4 leading-snug">
                To build India&apos;s most trusted frozen food network — where quality, not urgency, sets the price.
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                We connect every link in the cold chain — from the farmer and fisherman who produce, to the warehouse that stores, the transporter who moves, and the buyer who consumes — on a single platform where specifications are standard, capacity is visible, and trust is built into every transaction.
              </p>
              <div className="mt-6 flex items-center gap-2 text-xs text-primary-600 font-medium">
                <i className="ri-arrow-right-line"></i>
                <span>For everyone in the chain</span>
              </div>
            </div>
          </div>

          {/* Vision */}
          <div className="group relative bg-card-50 rounded-2xl border border-accent-200/30 p-8 md:p-10 shadow-sm hover:shadow-md hover:border-accent-300/50 transition-all cursor-default overflow-hidden card-animate">
            <div className="absolute top-0 right-0 w-32 h-32 bg-accent-100/40 rounded-bl-full -mr-4 -mt-4"></div>
            <div className="relative z-10">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 mb-5">
                <span className="text-xs font-semibold text-accent-700 uppercase tracking-wider">Vision</span>
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-bold text-accent-700 mb-4 leading-snug">
                A future where nothing good is wasted, and nothing fresh waits.
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                We envision an India where every harvest, every catch, and every batch of produce is captured at its peak — frozen, stored, and delivered through a transparent, efficient network that serves producers and consumers equally well. A country where the cold chain is not a bottleneck but a competitive advantage.
              </p>
              <div className="mt-6 flex items-center gap-2 text-xs text-accent-600 font-medium">
                <i className="ri-arrow-right-line"></i>
                <span>Built for India&apos;s next decade</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}